export const LEGACY_RESULT_SCHEMA = 1;
export const CURRENT_RESULT_SCHEMA = 2;

export function parseResultSchema(value: unknown): 1 | 2 | null {
  if (value === undefined) return LEGACY_RESULT_SCHEMA;
  if (value === LEGACY_RESULT_SCHEMA || value === CURRENT_RESULT_SCHEMA) return value;
  return null;
}
